/**
 * State.
 */
export const state: any = {
  load: false
}

/**
 * Getters.
 */
export const getters: any = {
  load (state: any): boolean {
    return state.load
  }
}

/**
 * Mutations.
 */
export const mutations: any = {
  LOADER (state: any, payload: boolean): void {
    state.load = payload
  }
}

/**
 * Actions.
 */
export const actions: any = {
  /**
   * Events loading component.
   */
  L04D ({ commit }: any, params: boolean): void {
    if (params) {
      commit('LOADER', params)
    } else {
      setTimeout(() => { commit('LOADER', params) }, 320)
    }
  }
}